import { render, staticRenderFns } from "./collecAdd.vue?vue&type=template&id=232437f2&scoped=true"
import script from "./collecAdd.vue?vue&type=script&lang=js"
export * from "./collecAdd.vue?vue&type=script&lang=js"
import style0 from "./collecAdd.vue?vue&type=style&index=0&id=232437f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232437f2",
  null
  
)

export default component.exports